import React from "react";
import { Toolbar } from "../Toolbar/Toolbar";
import {
  AppBar,
  Typography,
  makeStyles,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import { useSelector } from "react-redux";

const useStyles = makeStyles((theme) => ({
  root: {
    height: "64px",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    paddingLeft: "20px",
    backgroundColor: "#f5f5f5",
    [theme.breakpoints.up("md")]: {
      paddingRight: "25px",
    },
  },
  title: {
    fontSize: "0.9rem",
    fontWeight: "bold",
  },
}));

const Header = () => {
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const itemTitle = useSelector(
    (state) => state.configurator.configuration.item.title
  );

  return (
    <AppBar className={classes.root}>
      <Typography variant="body2" className={classes.title}>
        {itemTitle}
      </Typography>
      <Toolbar isMobile={isMobile} />
    </AppBar>
  );
};

export default Header;
